import PageControls from './Controls/PageControls/PageControls';
import ViewControls from './ViewControls';
export default ViewControls;
export { PageControls };
